let checkPathInNavBar = function () {
    let path = document.location.pathname;
    document.querySelectorAll('nav a').forEach((a) => {
        if (a.getAttribute('href') == path) {
            a.classList.add('active');
        } else {
            a.classList.remove('active');
        }
    });
};
checkPathInNavBar();

window.addEventListener('hashchange', checkPathInNavBar);

const syncBodyLock = (menu) => {
    document.body.classList.toggle('menu-open', menu?.classList.contains('active') ?? false);
};

document.querySelector('header .menu .menu-toggle').addEventListener('click', (e) => {
    const menu = e.currentTarget.closest('.menu');
    menu?.classList.toggle('active');
    syncBodyLock(menu);
});

document.querySelectorAll('header .menu a, header .menu button:not(.menu-toggle)').forEach(a => {
    // If menu toggle is visible (mobile view)
    // then close the menu when a link is clicked
    a.addEventListener('click', (e) => {
        const menu = e.currentTarget.closest('.menu');
        menu?.classList.remove('active');
        syncBodyLock(menu);
    })
});

document.querySelectorAll('header .menu > ul > li').forEach((li) => {
    li.addEventListener('click', (e) => {
        e.currentTarget.classList.toggle('active');
    });
    li.addEventListener('mouseover', (e) => {
        e.currentTarget.classList.add('active');
    });
    li.addEventListener('mouseout', (e) => {
        e.currentTarget.classList.remove('active');
    });

});
document.querySelectorAll('header .menu > ul > li ul').forEach((submenu) => {
    submenu.addEventListener('mouseover', (e) => {
        e.currentTarget.parentElement.classList.add('active');
    });
    submenu.addEventListener('mouseout', (e) => {
        e.currentTarget.parentElement.classList.remove('active');
    });
});


window.activeLanguage = localStorage.language != null ? localStorage.language : document.location.pathname.split('/')[1];
document.querySelectorAll('header nav .lang a').forEach((a) => {
    if (window.activeLanguage === a.rel) {
        a.classList.add('active');
        a.href = 'javascript:return';
    } else {
        let path = document.location.pathname.split('/');
        path.shift();
        path.shift();
        a.href = '/' + a.rel + '/' + path.join('/');
    }
});
